import arrayTrimEnd     from '../utils/arrayTrimEnd';

export interface Applicant {
    fname               : string;
    lname               : string;
    mailAddress         : string;
    homeAddress         : (string|undefined);
    dob                 : number; // Linux timestamp
    emailAddress        : string;
    phoneNumber         : string;
};

export interface Review {
    at                  : number;
    clerkId             : string;   // ID of the clerk who reviewed this application
    decision            : string;
}
export interface Application {
    _id                 : string;
    createdAt           : number;
    updatedAt           : number;
    agencyId            : string;
    applicant?          : Applicant;
    questionnaire       : Record<string,string>;
    submissionId?       : string;
    review?             : Review;
}

export type Hydrated = Omit<Application,''>;

export type Dehydrated = [
    string,
    number,
    number,
    string,
    ([
        string,
        string,
        string,
        (string|undefined),
        number,
        string,
        string
    ]|undefined),
    Record<string,string>,
    (string|undefined),
    ([
        number,
        string,
        string
    ]|undefined)
];

export const hydrate = ( app:Dehydrated ) : Hydrated => {
    if( !Array.isArray(app) )
        throw Error(`Invalid argument`);
    return {
        _id                         : app[0],
        createdAt                   : app[1],
        updatedAt                   : app[2],
        agencyId                    : app[3],
        applicant                   : app[4] ? {
            fname                   : app[4][0],
            lname                   : app[4][1],
            mailAddress             : app[4][2],
            homeAddress             : app[4][3],
            dob                     : app[4][4],
            emailAddress            : app[4][5],
            phoneNumber             : app[4][6]
        } : undefined,
        questionnaire               : app[5],
        submissionId                : app[6],
        review                      : app[7] ? {
            at                      : app[7][0],
            clerkId                 : app[7][1],
            decision                : app[7][2]
        } : undefined
    };
}

export const dehydrate = ( app:Hydrated ) : Dehydrated => {
    if( Array.isArray(app) || (typeof app !== 'object') || (app===null)  )
        throw Error(`Invalid argument`);
    // Users are dehydrated before they are sent to the client
    const dehydrated = [
        app._id,
        app.createdAt,
        app.updatedAt,
        app.agencyId,
        app.applicant ? [
            app.applicant.fname,
            app.applicant.lname,
            app.applicant.mailAddress,
            app.applicant.homeAddress,
            app.applicant.dob,
            app.applicant.emailAddress,
            app.applicant.phoneNumber
        ] : undefined,
        app.questionnaire,
        app.submissionId,
        app.review ? [
            app.review.at,
            app.review.clerkId,
            app.review.decision
        ] : undefined
    ];
    return arrayTrimEnd(dehydrated) as Dehydrated;
}


export default Application;
